export const LANDING_CONTENT_DEFAULTS = {
  hero_points: [
    'Streamline Collaboration',
    'Boost Productivity',
    'Stay Connected Anywhere',
  ],
  overview_sections: [
    {
      title: 'What it does',
      description: 'Core platform capabilities for businesses.',
      items: [
        'Automates support replies',
        'Captures leads and routes intent',
        'Escalates to human agents when needed',
      ],
    },
    {
      title: 'Who it is for',
      description: 'Ideal customer segments for this platform.',
      items: [
        'SaaS teams',
        'E-commerce stores',
        'Agencies managing many brands',
      ],
    },
    {
      title: 'Key benefits',
      description: 'Business value your users get immediately.',
      items: [
        'Faster response time',
        'Lower support overhead',
        'Consistent customer experience',
      ],
    },
    {
      title: 'How it works',
      description: 'Simple setup flow for new customers.',
      items: [
        'Train with your content',
        'Deploy widget and WhatsApp',
        'Monitor and optimize with analytics',
      ],
    },
    {
      title: 'Feature groups',
      description: 'Major capability buckets in the product.',
      items: [
        'AI chat and memory',
        'Knowledge training',
        'Live handover and channels',
      ],
    },
    {
      title: 'Use cases',
      description: 'Common business scenarios supported.',
      items: [
        'Customer support automation',
        'Pre-sales qualification',
        'Order and account assistance',
      ],
    },
  ],
  comparison_ours_label: 'Us',
  comparison_others_label: 'Others',
  comparison: [
    { label: 'Setup time', ours: 'Minutes', others: 'Days' },
    { label: 'Handover support', ours: 'Built-in', others: 'Add-on' },
    { label: 'Omnichannel', ours: 'Widget plus WhatsApp', others: 'Single channel' },
  ],
  pricing_popular_label: 'Most Popular',
  pricing_monthly_suffix: '/mo',
  pricing_yearly_prefix: 'Billed yearly at',
  pricing_button_text: 'Choose plan',
  pricing_button_url: '/signup',
  faq: [
    {
      q: 'Can I start free?',
      a: 'Yes, depending on how the admin configured the available plans.',
    },
    {
      q: 'Can I switch plans later?',
      a: 'Yes, plans can be upgraded or changed from the dashboard.',
    },
    {
      q: 'Does it support human handover?',
      a: 'Yes, chats can be routed to live agents when needed.',
    },
  ],
  final_cta: {
    title: 'Ready to launch your AI assistant?',
    subtitle: 'Start with the plan that matches your growth stage.',
    button_text: 'Start now',
    button_url: '/signup',
  },
};

export function cloneLandingDefaults() {
  return JSON.parse(JSON.stringify(LANDING_CONTENT_DEFAULTS));
}
